import { render, staticRenderFns } from "./Regional_Partner.vue?vue&type=template&id=f67648ba&scoped=true"
import script from "./Regional_Partner.vue?vue&type=script&lang=js"
export * from "./Regional_Partner.vue?vue&type=script&lang=js"
import style0 from "./Regional_Partner.vue?vue&type=style&index=0&id=f67648ba&prod&scoped=true&lang=less"
import style1 from "./Regional_Partner.vue?vue&type=style&index=1&id=f67648ba&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67648ba",
  null
  
)

export default component.exports